import BaseApi from './baseApi';
import IInboundDeliveryNotes from '../models/IInboundDeliveryNotes';
import IAuthentication from '../models/IAuthentication';
export default class InboundDeliveryNotesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundDeliveryNotesShared(idCompany: string, idStatus: string | null) {
        let json : string = this.getJsonReadShared(idCompany, idStatus);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDeliveryNotes: IInboundDeliveryNotes[] = [];
            inboundDeliveryNotes = response.data as IInboundDeliveryNotes[];
            return inboundDeliveryNotes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundCodesWhereDeliveryNoteDetailExists(inboundId: string) {
        let json : string = this.getJsonReadWhereDeliveryNoteDetailExists(inboundId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var codes: string[] = [];
            codes = response.data as string[];
            return codes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundDeliveryNotes(idInbound: string) : Promise<IInboundDeliveryNotes[]> {
        let json : string = this.getJsonRead(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDeliveryNotes: IInboundDeliveryNotes[] = [];
            inboundDeliveryNotes = response.data as IInboundDeliveryNotes[];
            return inboundDeliveryNotes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundDeliveryNotesByCompanyId(idCompany: string) : Promise<IInboundDeliveryNotes[]> {
        let json : string = this.getJsonReadByCompanyId(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDeliveryNotes: IInboundDeliveryNotes[] = [];
            inboundDeliveryNotes = response.data as IInboundDeliveryNotes[];
            return inboundDeliveryNotes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundDeliveryNotesToCompleted(id: string) {
        const json = this.getJsonSaveSharedToCompleted(id);
        const response = await this.api.post('exec', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async SaveInboundDeliveryNotes(inboundDeliveryNotes: IInboundDeliveryNotes) : Promise<string> {
        const json = this.getJsonSave(inboundDeliveryNotes);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundDeliveryNotes(inboundDeliveryNotes: IInboundDeliveryNotes) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundDeliveryNotes);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotes(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDeliveryNotesByInboundId(inboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundId(inboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonReadWhereDeliveryNoteDetailExists(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "code"
            }],
            "tables": [{
                "Item1": "OutboundsDetail"
            }, {
                "Item1": "Outbounds"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDeliveryNotes"
            }, {
                "Item1": "Inbounds"
            }],
            "joins": [{
                "Item1": "OutboundsDetail",
                "Item2": "IdOutbound",
                "Item3": "Outbounds",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "id",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "IdInboundDeliveryNote"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": idInbound
            }]
        };
        return json;
    }

    private getJsonDeleteByInboundId(inboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotes",
            "conditions": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": inboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotes",
            "conditions": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSaveSharedToCompleted(id: string) {
        const json = {
            "spname": "dbo.STOCK_INBOUND_DELIVERY_NOTE",
            "parameters": [{
                "Item1": "Id",
                "Item2": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundDeliveryNotes: IInboundDeliveryNotes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInbound",
                "Item2": inboundDeliveryNotes.idInbound
            }, {
                "Item1": "idCompanySource",
                "Item2": inboundDeliveryNotes.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": inboundDeliveryNotes.idCompanyDestination
            }, {
                "Item1": "idWarehouse",
                "Item2": inboundDeliveryNotes.idWarehouse
            }, {
                "Item1": "idCustomer",
                "Item2": inboundDeliveryNotes.idCustomer
            }, {
                "Item1": "code",
                "Item2": inboundDeliveryNotes.code
            }, {
                "Item1": "dateIn",
                "Item2": inboundDeliveryNotes.dateIn
            }, {
                "Item1": "description",
                "Item2": inboundDeliveryNotes.description
            }, {
                "Item1": "idStatus",
                "Item2": inboundDeliveryNotes.idStatus
            }, {
                "Item1": "idDock",
                "Item2": inboundDeliveryNotes.idDock
            }, {
                "Item1": "dockPicked",
                "Item2": inboundDeliveryNotes.dockPicked
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotes"
        };
        return json;
    }

    private getJsonUpdate(inboundDeliveryNotes: IInboundDeliveryNotes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInbound",
                "Item2": inboundDeliveryNotes.idInbound
            }, {
                "Item1": "idCompanySource",
                "Item2": inboundDeliveryNotes.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": inboundDeliveryNotes.idCompanyDestination
            }, {
                "Item1": "idWarehouse",
                "Item2": inboundDeliveryNotes.idWarehouse
            }, {
                "Item1": "idCustomer",
                "Item2": inboundDeliveryNotes.idCustomer
            }, {
                "Item1": "code",
                "Item2": inboundDeliveryNotes.code
            }, {
                "Item1": "dateIn",
                "Item2": inboundDeliveryNotes.dateIn
            }, {
                "Item1": "description",
                "Item2": inboundDeliveryNotes.description
            }, {
                "Item1": "idStatus",
                "Item2": inboundDeliveryNotes.idStatus
            }, {
                "Item1": "idDock",
                "Item2": inboundDeliveryNotes.idDock
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDeliveryNotes",
            "keyvalue": inboundDeliveryNotes.id
        };
        return json;
    }

    private getJsonRead(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = InboundsDeliveryNotes.IdCompanySource) as companySourceName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = InboundsDeliveryNotes.IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select Name from Warehouses where id = IdWarehouse) as warehouseName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCustomer"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = InboundsDeliveryNotes.IdCustomer) as customerName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "code"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "dateIn"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "description"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idStatus"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "name as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeSource"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idDock"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListDocks where id = InboundsDeliveryNotes.IdDock) as dockName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "dockPicked"
            }],
            "tables": [{
                "Item1": "InboundsDeliveryNotes"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes"
            }, {
                "Item1": "Inbounds"
            }],
            "joins": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idStatus",
                "Item3": "ListStatusInboundsDeliveryNotes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": idInbound
            }]
        };
        return json;
    }

    private getJsonReadShared(idCompany: string, idStatus: string | null) : any {
        const json = {
            "fields": [{
                "Item1": "",
                "Item2": "*"
            }],
            "tables": [{
                "Item1": "GetDelegatedInboundsDeliveryNotes('" + idCompany + "', '" + idStatus + "')"
            }]
        };
        return json;
    }

    private getJsonReadByCompanyId(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as inboundCode"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCompanySource"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "Name as warehouseName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "code"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "dateIn"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "description"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idStatus"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "name as statusName"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeSource"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idDock"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListDocks where id = InboundsDeliveryNotes.idDock) as dockname"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "dockPicked"
            }],
            "tables": [{
                "Item1": "InboundsDeliveryNotes"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes"
            }],
            "joins": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idStatus",
                "Item3": "ListStatusInboundsDeliveryNotes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany
            }]
        };
        return json;
    }
}
